// MenuDrawer.js
import React from "react";
import { Drawer, Box, Stack, Button, Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import MapIcon from "@mui/icons-material/Map";
import CompareIcon from "@mui/icons-material/Compare";
import BarChartIcon from "@mui/icons-material/BarChart";
import TuneIcon from "@mui/icons-material/Tune";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import InsightsIcon from "@mui/icons-material/Insights";
import { useAuth } from "react-oidc-context";
import { Logout } from "@mui/icons-material";

export const MenuDrawer = ({
    menuOpen,
    handleMenuToggle,
    showStats,
    setShowStats,
    showFilters,
    setShowFilters,
    showControls,
    setShowControls,
}) => {
    const auth = useAuth();

    const signOutRedirect = () => {
        auth.removeUser();
        const clientId = "3ldce2kkcugotrio4fsd6cvjkr";
        const logoutUri =
            window.location.hostname === "localhost"
                ? "http://localhost:3000"
                : window.location.origin;
        const cognitoDomain =
            "https://us-east-2se0l4tygk.auth.us-east-2.amazoncognito.com";
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    };

    return (
        <Drawer
            anchor="right"
            open={menuOpen}
            onClose={handleMenuToggle}
            PaperProps={{
                sx: { width: 280 },
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                }}
            >
                {/* View Controls Section */}
                <Box>
                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 2, pl: 1, fontWeight: 600 }}
                    >
                        View Controls
                    </Typography>
                    <Stack spacing={1}>
                        <Button
                            variant="outlined"
                            fullWidth
                            startIcon={
                                showStats ? (
                                    <VisibilityOffIcon />
                                ) : (
                                    <VisibilityIcon />
                                )
                            }
                            onClick={() => setShowStats(!showStats)}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            {showStats ? "Hide Statistics" : "Show Statistics"}
                        </Button>
                        <Button
                            variant="outlined"
                            fullWidth
                            startIcon={
                                showFilters ? (
                                    <FilterListOffIcon />
                                ) : (
                                    <FilterListIcon />
                                )
                            }
                            onClick={() => setShowFilters(!showFilters)}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            {showFilters ? "Hide Filters" : "Show Filters"}
                        </Button>
                        <Button
                            variant="outlined"
                            fullWidth
                            startIcon={
                                showControls ? <TuneIcon /> : <SettingsIcon />
                            }
                            onClick={() => setShowControls(!showControls)}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            {showControls
                                ? "Hide Map Controls"
                                : "Show Map Controls"}
                        </Button>
                    </Stack>
                </Box>

                <Divider />

                {/* Navigation Section */}
                <Box>
                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 2, pl: 1, fontWeight: 600 }}
                    >
                        Navigation
                    </Typography>
                    <Stack spacing={1}>
                        <Button
                            variant="outlined"
                            fullWidth
                            component={Link}
                            to="/"
                            startIcon={<MapIcon />}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            Location Map
                        </Button>

                        <Button
                            variant="outlined"
                            fullWidth
                            component={Link}
                            to="/network-comparison"
                            startIcon={<CompareIcon />}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            Network Hardware
                        </Button>

                        <Button
                            variant="outlined"
                            fullWidth
                            component={Link}
                            to="/cost-comparison"
                            startIcon={<BarChartIcon />}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            Cost Analysis
                        </Button>

                        <Button
                            variant="outlined"
                            fullWidth
                            component={Link}
                            to="/ai"
                            startIcon={<InsightsIcon />}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                        >
                            Ingenuity AI
                        </Button>
                    </Stack>
                </Box>
                {/* Account Section */}
                <Box>
                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 2, pl: 1, fontWeight: 600 }}
                    >
                        Account
                    </Typography>
                    <Stack spacing={1}>
                        <Button
                            variant="outlined"
                            fullWidth
                            component={Link}
                            startIcon={<Logout />}
                            sx={{ justifyContent: "flex-start", height: 42 }}
                            onClick={signOutRedirect}
                        >
                            Sign Out
                        </Button>
                    </Stack>
                </Box>
            </Box>
        </Drawer>
    );
};
